import { useEffect, useState } from "react";
import Select from 'react-select';
import { GetInvoiceData} from '../../store/invoiceAtom';



function InvoiceWareHouseSelect(props) {
  const masterData = GetInvoiceData();

  const customOption = masterData?.warehouse?.map((item)=> {
    return ({...item, label:`${item.Warehouse_Name}`})
  })

  
  const customStyles = {
    control: base => ({
      ...base,
      height: 49.9,
      backgroundColor: '#F1F1F1',
    //   width: 450,
    }),
    indicatorSeparator: styles => ({ ...styles, display : 'none' }),
    // placeholder: styles => ({ ...styles, display : 'none' }),
    valueContainer: styles => ({ ...styles, backgroundColor: '',height: 20, paddingBottom:"45px", marginLeft:"13px"}),
    option: styles => ({ ...styles, backgroundColor: '#F1F1F1', color:"black"}),

  
    
  }

    const handleChange = (value) => {
      props.onWareHouseSelect(value)
      };


    return ( 
        <>
   
         <Select  placeholder={"Select warehouse..."}   styles={customStyles} onChange={handleChange} 
          defaultValue={props?.defaultVal}
          options={customOption}
         />


        </>
     );
}

export default InvoiceWareHouseSelect;
